function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var SvgConvocatoriaHome = function SvgConvocatoriaHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    style: {
      enableBackground: "new 0 0 160 160"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BCF0F6"
    },
    cx: 80,
    cy: 80,
    r: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 35,
    style: {
      fill: "#EDEDED"
    },
    width: 70,
    height: 90
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 56,
    style: {
      fill: "#D5007F"
    },
    width: 70,
    height: 12.001
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 41,
    style: {
      fill: "#333333"
    },
    width: 54,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 75,
    style: {
      fill: "#919191"
    },
    width: 54,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 89,
    style: {
      fill: "#919191"
    },
    width: 54,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 103,
    style: {
      fill: "#919191"
    },
    width: 54,
    height: 6
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConvocatoriaHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/convocatoriaHome.23291bf7.svg";
export { ForwardRef as ReactComponent };